import { render, staticRenderFns } from "./KVKQuestion.vue?vue&type=template&id=0e0601ee&scoped=true"
import script from "./KVKQuestion.vue?vue&type=script&lang=js"
export * from "./KVKQuestion.vue?vue&type=script&lang=js"
import style0 from "./KVKQuestion.vue?vue&type=style&index=0&id=0e0601ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0601ee",
  null
  
)

export default component.exports